module.exports = __webpack_public_path__ + "img/digital_card_summer.6871e5e5.png";